// src/constants/permissions.js
export const PERMISSIONS = {
  // ── User Management ──
  USERS_CREATE: "users:create",
  USERS_READ: "users:read",
  USERS_UPDATE: "users:update",
  USERS_DELETE: "users:delete",
  USERS_ASSIGN_ROLE: "users:assign_role",

  // ── Hospital & Department ──
  HOSPITAL_MANAGE: "hospital:manage",
  DEPARTMENT_MANAGE: "department:manage",
  DEPARTMENT_READ: "department:read",
  DEPARTMENT_MANAGE_STAFF: "department:manage_staff",

  // ── Patient Identity ──
  PATIENTS_REGISTER: "patients:register",
  PATIENTS_READ: "patients:read",
  PATIENTS_UPDATE: "patients:update",
  PATIENTS_SEARCH: "patients:search",
  PATIENTS_LINK_ABHA: "patients:link_abha",
  PATIENTS_VIEW_HISTORY: "patients:view_history",

  // ── OPD & Queue Management ──
  OPD_ADD_VISIT: "opd:add_visit",
  OPD_VIEW_QUEUE: "opd:view_queue",
  OPD_NEXT_PATIENT: "opd:next_patient",
  OPD_CANCEL_VISIT: "opd:cancel_visit",
  OPD_STATS: "opd:stats",
  OPD_UPDATE_SERVING: "opd:update_serving",

  // ── Clinical Records ──
  CLINICAL_PRESCRIPTION_WRITE: "clinical:prescription:write",
  CLINICAL_PRESCRIPTION_READ: "clinical:prescription:read",
  CLINICAL_SOAP_WRITE: "clinical:soap:write",
  CLINICAL_SOAP_READ: "clinical:soap:read",
  CLINICAL_DISCHARGE_WRITE: "clinical:discharge:write",
  CLINICAL_DISCHARGE_READ: "clinical:discharge:read",
  CLINICAL_ASSESSMENT_WRITE: "clinical:assessment:write",
  CLINICAL_ASSESSMENT_READ: "clinical:assessment:read",
  CLINICAL_IMMUNIZATION_WRITE: "clinical:immunization:write",

  // ── Lab Reports ──
  LAB_ORDER: "lab:order",
  LAB_ENTER_RESULTS: "lab:enter_results",
  LAB_FINALIZE: "lab:finalize",
  LAB_READ: "lab:read",
  LAB_READ_RESULTS: "lab:read",
  LAB_VIEW_TEMPLATES: "lab:view_templates",

  // ── Billing & Finance ──
  BILLING_CREATE: "billing:create",
  BILLING_READ: "billing:read",
  BILLING_PROCESS_PAYMENT: "billing:process_payment",
  BILLING_REPORTS: "billing:reports",
  // Aliases for compatibility
  BILLING_CREATE_INVOICE: "billing:create",
  BILLING_READ_INVOICE: "billing:read",
  BILLING_COLLECT_PAYMENT: "billing:process_payment",

  // ── Pharmacy ──
  PHARMACY_DISPENSE: "pharmacy:dispense",
  PHARMACY_VIEW_ORDERS: "pharmacy:view_orders",

  // ── ABDM & Consent ──
  ABDM_LINK_CARECONTEXT: "abdm:link_carecontext",
  ABDM_CONSENT_INITIATE: "abdm:consent:initiate",
  ABDM_CONSENT_READ: "abdm:consent:read",
  ABDM_HIU_FETCH: "abdm:hiu:fetch",

  // ── Security, Platform & Audit ──
  SYSTEM_CONFIG: "system:config",
  SYSTEM_AUDIT_LOGS: "system:audit_logs",
  SYSTEM_SESSIONS: "system:sessions",
  SMS_SEND: "sms:send",
  TERMINOLOGY_SEARCH: "terminology:search",
  AUDIT_LOGS_READ: "system:audit_logs",
};

export const ROLES = {
  SUPER_ADMIN: 1,
  HOSPITAL_ADMIN: 2,
  DOCTOR: 3,
  STAFF: 4,
  NURSE: 5,
  LAB_TECHNICIAN: 6,
  PHARMACIST: 7,
  BILLING: 8,
  RECEPTIONIST: 9,
  DEPARTMENT_HEAD: 10,
  AUDITOR: 11,
};
